import { css } from '@emotion/css';

export const operatorStyles = css`
  width: 26%;
`;
